<script setup lang="ts">
import { computed } from 'vue'

import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'ImportCurriculumHeader',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'import-curriculum',
    text: 'Import Curriculum',
    to: AppRoute.ImportCurriculum,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
